import { useEffect } from 'react';

import { useClientContext } from '@bessemercws/providers';
import { decode } from 'base-64';
import { useParams } from 'react-router-dom';

export const useSetClientIdFromPath = () => {
  const { clientId: encodedClientId } = useParams();
  const clientId = encodedClientId ? decode(encodedClientId) : '';
  const { setSelectedClient } = useClientContext();

  useEffect(() => {
    if (clientId) {
      setSelectedClient(clientId);
    }
  }, [clientId]);
};
